import _ from 'lodash';

// 速度对象
interface ResultObj {
  speed: number;
  unit: string;
}

// 单位
const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

// 进制
const systemNumber = 1024;

// 记录递归的次数
let index = 0;

/**
 * @return speed 网络速度; unit 速度单位;
 * @param speed 网络速度单位 byte
 */
export function getSpeedAndUnit(speed: number): ResultObj {
  const result: ResultObj = {
    speed,
    unit: units[index],
  };
  if (speed <= 0) {
    return {
      speed: 0,
      unit: 'KB',
    };
  }
  if (speed >= 1000 && index < units.length - 1) {
    index++;
    // eslint-disable-next-line no-param-reassign
    return getSpeedAndUnit(_.divide(speed, systemNumber));
  }
  index = 0;
  result.speed = _.floor(result.speed, 1);
  return result;
}
